import { RouterModule, Routes } from '@angular/router';
import { EditTruckComponent } from './trucks/edit-truck/edit-truck.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { TrucksComponent } from './trucks/trucks.component';
import { HomeComponent } from './component/home/home.component';
import { NgModule } from '@angular/core';
import { ModFinanComponent } from './component/menu/consultas/mod-finan/mod-finan.component';
import { ConsultaBancosComponent } from './component/menu/consultas/consulta-bancos/consulta-bancos.component';
import { FrontOfficesComponent } from './component/menu/consultas/front-offices/front-offices.component';
import { SolicCriticaComponent } from './component/menu/consultas/solic-critica/solic-critica.component';
import { ModeloProdutosComponent } from './component/menu/consultas/modelo-produtos/modelo-produtos.component';
import { CadastroBancosComponent } from './component/menu/cadastros/cadastro-bancos/cadastro-bancos.component';
import { DealersFofComponent } from './component/menu/cadastros/dealers-fof/dealers-fof.component';
import { StatusComponent } from './component/menu/cadastros/status/status.component';
import { CriticasComponent } from './component/menu/cadastros/criticas/criticas.component';
import { ClientesComponent } from './component/menu/cadastros/clientes/clientes.component';
import { MotivoFupComponent } from './component/menu/admin/motivo-fup/motivo-fup.component';
import { ProgramaBndesComponent } from './component/menu/admin/programa-bndes/programa-bndes.component';
import { FaturadasComponent } from './component/menu/consultas/faturadas/faturadas.component';
import { CanceladasComponent } from './component/menu/consultas/canceladas/canceladas.component';
import { AutVencidasComponent } from './component/menu/consultas/aut-vencidas/aut-vencidas.component';
import { SolicFofBancoComponent } from './component/menu/consultas/solic-fof-banco/solic-fof-banco.component';
import { EmailsPadraoComponent } from './component/menu/admin/emails-padrao/emails-padrao.component';
import { ProcessamentoComponent } from './component/menu/admin/processamento/processamento.component';
import { SolicitacoesComponent } from './component/menu/solicitacoes/solicitacoes.component';
import { ListaCreditosComponent } from './component/menu/consultas/lista-creditos/lista-creditos.component';
import { DealersGenComponent } from './component/menu/cadastros/dealers-gen/dealers-gen.component';
import { UploadArquivosComponent } from './component/menu/admin/upload-arquivos/upload-arquivos.component';
import { DesistenciaComponent } from './component/menu/consultas/desistencia/desistencia.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'Home', component: HomeComponent, title: 'CA - Credit Assessment'},
  { path: 'Solicitacoes', component: SolicitacoesComponent, title: 'Solicitações'},
  { path: 'Cadastros/Bancos', component: CadastroBancosComponent, title: 'Bancos'},
  { path: 'Cadastros/DealersFrontOffices', component: DealersFofComponent, title: 'Dealers & Front Offices'},
  { path: 'Cadastros/Status', component: StatusComponent, title: 'Status'},
  { path: 'Cadastros/Criticas', component: CriticasComponent, title: 'Críticas'},
  { path: 'Cadastros/Clientes', component: ClientesComponent, title: 'Clientes'},
  { path: 'Cadastros/DealersGen', component: DealersGenComponent, title: 'Dealers e Gen'},
  { path: 'Consultas/ModFinanciamento', component: ModFinanComponent, title: 'Modalidade Financiamento'},
  { path: 'Consultas/Bancos', component: ConsultaBancosComponent, title: 'Bancos'},
  { path: 'Consultas/FrontOffices', component: FrontOfficesComponent, title: 'Front Offices'},
  { path: 'Consultas/SolicitacaoCritica', component: SolicCriticaComponent, title: 'Solicitações em Crítica'},
  { path: 'Consultas/ModeloProdutos', component: ModeloProdutosComponent, title: 'Modelo de Produtos'},
  { path: 'Consultas/Faturadas', component: FaturadasComponent, title: 'Faturadas'},
  { path: 'Consultas/Canceladas', component: CanceladasComponent, title: 'Canceladas'}, 
  { path: 'Consultas/Desistencia', component: DesistenciaComponent, title: 'Desistência'},
  { path: 'Consultas/AutVencidas', component: AutVencidasComponent, title: 'Autorizações Vencidas'},
  { path: 'Consultas/ListaCredito', component: ListaCreditosComponent, title: 'Lista de Créditos Concessionárias'},
  { path: 'Consultas/FrontOfficeRequest', component: SolicFofBancoComponent, title: 'Solicitação para Front Office'},
  { path: 'Admin/Processamento', component: ProcessamentoComponent, title: 'Processamento'},
  { path: 'Admin/EmailsPadrao', component: EmailsPadraoComponent, title: 'Emails para Envio de Autorizações'},
  { path: 'Admin/MotivoFup', component: MotivoFupComponent, title: 'Motivo para Follow Up'},
  { path: 'Admin/UploadArquivos', component:UploadArquivosComponent, title: 'Upload de Arquivos'},
  { path: 'Admin/ProgramaBndes', component: ProgramaBndesComponent, title: 'Programa BNDES'},
  { path: 'trucks/edit/:id', component: EditTruckComponent, pathMatch: 'full' },
  { path: 'home', component: WelcomeComponent, pathMatch: 'full' },
  { path: 'trucks', component: TrucksComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutesModule {}